import type { OrganizationSettings } from 'src/types';
import { baseFetch } from 'src/utils';

export const updateSettingsAPI = async (settings: OrganizationSettings) => {
  const res = await baseFetch(`/api/org/settings`, {
    method: 'PUT',
    body: JSON.stringify(settings),
  });

  if (!res.ok) {
    throw new Error('Failed to update settings');
  }

  return true;
};
